var map = {
	"./1 chest four horsemen apocalypse.1280x1707.webp": 83,
	"./2 demon horns color leg.1280x1507.webp": 84,
	"./3 leg color face black.1280x1600.webp": 85,
	"./4 lion back black white.1280x1674.webp": 86,
	"./5 lion leg black white.1280x1480.webp": 87,
	"./6 wolf triangles arm black white.1280x1707.webp": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;